import { render, staticRenderFns } from "./UpdateAppOccupationInfo.vue?vue&type=template&id=a479084c&"
import script from "./UpdateAppOccupationInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateAppOccupationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports